/**
 * Format a duration in seconds as `mm:ss`, or `h:mm:ss` once it reaches an
 * hour. Minutes and seconds are zero-padded; hours are not.
 *
 * Shared by the audio waveform and the call event card so a long recording
 * renders as `1:30:00` rather than `90:00`.
 */
export function formatDuration(totalSeconds: number): string {
    const seconds = Math.floor(totalSeconds);

    const h = Math.floor(seconds / 3600);
    const m = Math.floor((seconds % 3600) / 60)
        .toString()
        .padStart(2, '0');
    const s = Math.floor(seconds % 60)
        .toString()
        .padStart(2, '0');

    return h > 0 ? `${h}:${m}:${s}` : `${m}:${s}`;
}
